// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
    display: flex;
    flex-direction: row;
    /* Par défaut, la carte et le texte sont côte à côte */
    width: 100%;
    margin: 50px auto;
}

/* Le cadre a exactement le format de la carte : rien n'est rogné quand elle est entière */
.map-container {
    width: 50%;
    aspect-ratio: 1500 / 960;
    align-self: flex-start;
    position: relative;
    overflow: hidden;
}

.map-image {
    display: block;
    width: 100%;
    height: 100%;
    transform-origin: 0 0;
    transition: transform 0.5s ease-in-out;
    cursor: pointer;
}

.text-container {
    width: 50%;
    padding: 100px 20px 20px;
    display: flex;
    flex-direction: column;
    color:#F3ECD2;
}

.region-navigation {
    margin-top: 10px;
    flex-direction: row;
    display: flex;
    gap: 30px;
    align-items: center;
}

/* Menu des régions */
.choixRegion {
    position: relative;
}

.btn.choixRegion-bouton {
    gap: 14px;
    min-width: 260px;
    justify-content: space-between;
    transition: box-shadow 0.2s;
}

.btn.choixRegion-bouton:hover,
.btn.choixRegion-bouton.ouvert {
    box-shadow: 0 0 0 3px rgba(218, 177, 102, 0.35);
}

.choixRegion-chevron {
    width: 8px;
    height: 8px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translateY(-2px) rotate(45deg);
    transition: transform 0.2s;
}

.ouvert .choixRegion-chevron {
    transform: translateY(2px) rotate(225deg);
}

.choixRegion-liste {
    position: absolute;
    z-index: 10;
    top: calc(100% - 8px);
    left: 0;
    min-width: 100%;
    max-height: 60vh;
    overflow-y: auto;
    margin: 0;
    padding: 8px;
    list-style: none;
    background: #F3ECD2;
    border: 1px solid #DE9709;
    border-radius: 20px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
    outline: none;
    animation: choixRegion-ouverture 0.15s ease-out;
}

.choixRegion-liste li {
    padding: 8px 18px;
    border-radius: 50px;
    font-family: 'Playfair Display', serif;
    font-size: 16px;
    color: #030303;
    text-align: left;
    white-space: nowrap;
    cursor: pointer;
}

.choixRegion-liste li.active {
    background: #DAB166;
}

.choixRegion-liste li[aria-selected="true"] {
    color: #DE9709;
    font-weight: 700;
}

.choixRegion-liste li.active[aria-selected="true"] {
    color: #030303;
}

@keyframes choixRegion-ouverture {
    from { opacity: 0; transform: translateY(-6px); }
}

/* Pas assez de place sous le bouton : la liste s'ouvre au-dessus */
.choixRegion-liste.versHaut {
    top: auto;
    bottom: calc(100% - 8px);
    animation-name: choixRegion-ouverture-haut;
}

@keyframes choixRegion-ouverture-haut {
    from { opacity: 0; transform: translateY(6px); }
}

/* Inutile tant que la carte est entière : masqué sans décaler la mise en page */
.btn.carteEntiere {
    transition: opacity 0.3s, visibility 0.3s;
}

.btn.carteEntiere.cache {
    opacity: 0;
    visibility: hidden;
}

.videoUnivers {
    display: block;
    width: 100%;
    max-height: 80vh;
    aspect-ratio: 16 / 9;
}

/* Responsive */
@media (max-width:1200px) {
    .text-container {
        padding: 50px 20px 20px;
    }
    .region-navigation {
        flex-direction: column;
        gap: 0;
        align-items: start;
    }
}

@media (max-width:992px) {
    .app-container {
        flex-direction: column;
        /* Sur tablette et mobile, la carte passe au-dessus du texte */
    }
    .map-container,
    .text-container {
        width: 100%;
        /* La carte et le texte prennent toute la largeur */
    }
    .text-container {
        padding: 10px;
        text-align: center;
    }
    .text-container, .region-navigation {
        align-items: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/Univers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sDAAsD;IACtD,WAAW;IACX,iBAAiB;AACrB;;AAEA,0FAA0F;AAC1F;IACI,UAAU;IACV,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,qCAAqC;IACrC,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;AACpD;;AAEA,mEAAmE;AACnE;IACI,SAAS;IACT,wBAAwB;IACxB,0CAA0C;AAC9C;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;AACnD;;AAEA,gFAAgF;AAChF;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;QACtB,MAAM;QACN,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,8DAA8D;IAClE;IACA;;QAEI,WAAW;QACX,mDAAmD;IACvD;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".app-container {\n    display: flex;\n    flex-direction: row;\n    /* Par défaut, la carte et le texte sont côte à côte */\n    width: 100%;\n    margin: 50px auto;\n}\n\n/* Le cadre a exactement le format de la carte : rien n'est rogné quand elle est entière */\n.map-container {\n    width: 50%;\n    aspect-ratio: 1500 / 960;\n    align-self: flex-start;\n    position: relative;\n    overflow: hidden;\n}\n\n.map-image {\n    display: block;\n    width: 100%;\n    height: 100%;\n    transform-origin: 0 0;\n    transition: transform 0.5s ease-in-out;\n    cursor: pointer;\n}\n\n.text-container {\n    width: 50%;\n    padding: 100px 20px 20px;\n    display: flex;\n    flex-direction: column;\n    color:#F3ECD2;\n}\n\n.region-navigation {\n    margin-top: 10px;\n    flex-direction: row;\n    display: flex;\n    gap: 30px;\n    align-items: center;\n}\n\n/* Menu des régions */\n.choixRegion {\n    position: relative;\n}\n\n.btn.choixRegion-bouton {\n    gap: 14px;\n    min-width: 260px;\n    justify-content: space-between;\n    transition: box-shadow 0.2s;\n}\n\n.btn.choixRegion-bouton:hover,\n.btn.choixRegion-bouton.ouvert {\n    box-shadow: 0 0 0 3px rgba(218, 177, 102, 0.35);\n}\n\n.choixRegion-chevron {\n    width: 8px;\n    height: 8px;\n    border-right: 2px solid currentColor;\n    border-bottom: 2px solid currentColor;\n    transform: translateY(-2px) rotate(45deg);\n    transition: transform 0.2s;\n}\n\n.ouvert .choixRegion-chevron {\n    transform: translateY(2px) rotate(225deg);\n}\n\n.choixRegion-liste {\n    position: absolute;\n    z-index: 10;\n    top: calc(100% - 8px);\n    left: 0;\n    min-width: 100%;\n    max-height: 60vh;\n    overflow-y: auto;\n    margin: 0;\n    padding: 8px;\n    list-style: none;\n    background: #F3ECD2;\n    border: 1px solid #DE9709;\n    border-radius: 20px;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);\n    outline: none;\n    animation: choixRegion-ouverture 0.15s ease-out;\n}\n\n.choixRegion-liste li {\n    padding: 8px 18px;\n    border-radius: 50px;\n    font-family: 'Playfair Display', serif;\n    font-size: 16px;\n    color: #030303;\n    text-align: left;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.choixRegion-liste li.active {\n    background: #DAB166;\n}\n\n.choixRegion-liste li[aria-selected=\"true\"] {\n    color: #DE9709;\n    font-weight: 700;\n}\n\n.choixRegion-liste li.active[aria-selected=\"true\"] {\n    color: #030303;\n}\n\n@keyframes choixRegion-ouverture {\n    from { opacity: 0; transform: translateY(-6px); }\n}\n\n/* Pas assez de place sous le bouton : la liste s'ouvre au-dessus */\n.choixRegion-liste.versHaut {\n    top: auto;\n    bottom: calc(100% - 8px);\n    animation-name: choixRegion-ouverture-haut;\n}\n\n@keyframes choixRegion-ouverture-haut {\n    from { opacity: 0; transform: translateY(6px); }\n}\n\n/* Inutile tant que la carte est entière : masqué sans décaler la mise en page */\n.btn.carteEntiere {\n    transition: opacity 0.3s, visibility 0.3s;\n}\n\n.btn.carteEntiere.cache {\n    opacity: 0;\n    visibility: hidden;\n}\n\n.videoUnivers {\n    display: block;\n    width: 100%;\n    max-height: 80vh;\n    aspect-ratio: 16 / 9;\n}\n\n/* Responsive */\n@media (max-width:1200px) {\n    .text-container {\n        padding: 50px 20px 20px;\n    }\n    .region-navigation {\n        flex-direction: column;\n        gap: 0;\n        align-items: start;\n    }\n}\n\n@media (max-width:992px) {\n    .app-container {\n        flex-direction: column;\n        /* Sur tablette et mobile, la carte passe au-dessus du texte */\n    }\n    .map-container,\n    .text-container {\n        width: 100%;\n        /* La carte et le texte prennent toute la largeur */\n    }\n    .text-container {\n        padding: 10px;\n        text-align: center;\n    }\n    .text-container, .region-navigation {\n        align-items: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
